// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XNhr","tabsBox":"styles_tabsBox__2p23R","createButton":"styles_createButton__2Gj4u"};